import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import TierThumbHtmlView from './TierHtml';
import TierThumbReactView from './Tier';
const TierThumbView = (props)=>{
    if (props.isHtml) {
        return /*#__PURE__*/ React.createElement(TierThumbHtmlView, _extends({}, props));
    }
    return /*#__PURE__*/ React.createElement(TierThumbReactView, _extends({}, props));
};
TierThumbView.displayName = 'TierThumbView';
export default TierThumbView;
